var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{attrs:{"app":""}},[_c('v-toolbar-title',{staticClass:"mx-8"},[_vm._v("Flow Credit Assessment")]),_c('v-spacer'),_c('v-btn',{attrs:{"to":'/company/list',"text":""}},[_vm._v("Company List")]),_c('v-btn',{attrs:{"to":'/company/new',"text":""}},[_vm._v("New Company")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }